import React from "react";
import { RCCProgress } from "react-common-components";
import { Body, ContainerWithMargin, DivContent} from "src/components/Card/styles";
import OptionsOfActions from "src/pages/Actions/Panel/components/OptionsOfActions";
import { ActionSituationFilter, IListActions } from "src/pages/Actions/Panel/interface";
import { usePrioritizationMatrix } from "src/pages/Actions/PrioritizationMatrix/prioritizationMatrixContext";
import { ICardRiskPrioritizationMatrix } from "./interface";
import Container from "./styles";

const CardActionsPrioritizationMatrix: React.FC<ICardRiskPrioritizationMatrix> = ({
	data
}) => {

	const { 
		onLoad,
		openModalActionAddChange,
		openModalActionChangeProgress,
		openModalActionPostponement,
		openModalActionCancel,
		openModalActionDelete
	} = usePrioritizationMatrix();

	const colorSituation = (situation: any) => {
		let color: "grey" | "green" | "blue" | "red" | "yellow" | "purple" = "grey";
		switch(situation){
		case ActionSituationFilter.FINISHED:
			color = "green";
			break;
		case ActionSituationFilter.DELAYED:
			color = "red";
			break;
		case ActionSituationFilter.NOT_STARTED:
			color = "purple";
			break;
		case ActionSituationFilter.IN_PROGRESS:
			color = "blue";
			break;
		case ActionSituationFilter.NEXT_TO_EXPIRE:
			color = "yellow";
			break;
		default: 
			color = "grey";
			break;
		}
		return color;
	};

	const options = (row: IListActions) => (
		<OptionsOfActions 
			positionOptions="leftEnd"
			row={row}
			openModalAddOrChange={(isDisabled) => {
				if(!openModalActionAddChange)
					return;
			
				openModalActionAddChange(row.inb001Id, () => onLoad(), undefined, undefined, undefined, undefined, undefined, isDisabled);
			}}
			openModalAddSubaction={() => {
				if(!openModalActionAddChange)
					return;
			
				openModalActionAddChange(undefined, () => onLoad(), undefined, row.inb001Id);
			}}
			openModalChangeProgress={(isReopen: boolean) => {
				if(!openModalActionChangeProgress)
					return;

				openModalActionChangeProgress(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, row.inb001PercConclusao , () => onLoad(), isReopen);
			}}
			openModalActionPostponement={() => {
				if(!openModalActionPostponement)
					return;

				openModalActionPostponement(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, row.inb001Dtfim , () => onLoad());
			}}
			openModalActionCancel={() => {
				if(!openModalActionCancel)
					return;

				openModalActionCancel(row.inb001Id, `${row.inb001Codigo} - ${row.inb001Titulo}`, () => onLoad());
			}}
			actionButtonDelete={() => {
				if(!openModalActionDelete)
					return;

				openModalActionDelete(row);
			}}
		/>
	);

	return (
		<>
			<Container>
				<ContainerWithMargin color={colorSituation(data.situation)}>
					<Body>
						<RCCProgress 
							width="35px" 
							value={data.inb001PercConclusao} 
							layout="circle"
							styleInline=">span.value-text-circle{ font-size: 0.75rem; }"
						/>
						<DivContent style={{ marginLeft: "0.75rem" }}>
							{data.inb001Codigo} - {data.inb001Titulo}
						</DivContent>
						{options(data)}
					</Body>
				</ContainerWithMargin>
			</Container>
		</>
	);
};

export default CardActionsPrioritizationMatrix;
